// extracted by mini-css-extract-plugin
module.exports = {"tabs":"CareerTabs_tabs__bacgn","tab":"CareerTabs_tab__v_Lt5","active":"CareerTabs_active__GubZ_"};